import { AuthRedirectPage } from 'pages/AuthRedirectPage';
import { ForbiddenPage } from 'pages/ForbiddenPage';
import { IntegrationPage } from 'pages/IntegrationPage';
import { IntegrationConfigPage } from 'pages/IntegrationPage/components/ConfigPage/ConfigPage';
import { IntegrationInboundDocsPage } from 'pages/IntegrationPage/components/InboundDocsPage/InboundDocsPage';
import { IntegrationOverviewPage } from 'pages/IntegrationPage/components/OverviewPage/OverviewPage';
import { IntegrationSellerDocsPage } from 'pages/IntegrationPage/components/SellerDocsPage/SellerDocsPage';
import { IntegrationSellerReqsPage } from 'pages/IntegrationPage/components/SellerReqsPage/SellerReqsPage';
import { LoginRedirectPage } from 'pages/LoginRedirectPage';
import { MainPage } from 'pages/MainPage';
import { NotFoundPage } from 'pages/NotFoundPage';
import { SellerPage } from 'pages/SellerPage';
import { AdminIntegrationPage } from 'pages/SellerPage/components/AdminIntegrationPage/AdminIntegrationPage';
import { CompanyInfoPage } from 'pages/SellerPage/components/CompanyInfoPage/CompanyInfoPage';
import { MarketingInfoPage } from 'pages/SellerPage/components/MarketingInfoPage/MarketingInfoPage';
import { PoliciesInfoPage } from 'pages/SellerPage/components/PoliciesInfoPage/PoliciesInfoPage';
import { UsersInfoPage } from 'pages/SellerPage/components/UsersInfoPage/UsersInfoPage';
import { SellersPage } from 'pages/SellersPage';
import {
  AppRoutes,
  getRouteAdminIntegrationSellerPage,
  getRouteAuth,
  getRouteCompanySellerPage,
  getRouteForbidden,
  getRouteLogin,
  getRouteMain,
  getRouteMarketingSellerPage,
  getRouteNotFound,
  getRoutePoliciesSellerPage,
  getRouteSellerIntegrationsInboundDocsPage,
  getRouteSellerIntegrationsOverviewPage,
  getRouteSellerIntegrationsPage,
  getRouteSellerIntegrationsSellerConfigPage,
  getRouteSellerIntegrationsSellerDocsPage,
  getRouteSellerIntegrationsSellerReqsPage,
  getRouteSellerPage,
  getRouteSellers,
  getRouteUsersSellerPage,
} from 'shared/constants/routerConst';
import { UserRole, acceptableRolesForApp } from 'shared/constants/userRole';
import { AppRoutesProps } from 'shared/types/router';

export const routeConfig: Partial<Record<AppRoutes, AppRoutesProps>> = {
  [AppRoutes.MAIN]: {
    path: getRouteMain(),
    element: <MainPage />,
  },
  [AppRoutes.LOGIN]: {
    path: getRouteLogin(),
    element: <LoginRedirectPage />,
  },
  [AppRoutes.AUTH]: {
    path: getRouteAuth(),
    element: <AuthRedirectPage />,
  },
  [AppRoutes.SELLERS]: {
    roles: [UserRole.REOPS_ADMIN],
    authOnly: true,
    path: getRouteSellers(),
    element: <SellersPage />,
  },
  [AppRoutes.SELLER]: {
    roles: acceptableRolesForApp,
    authOnly: true,
    path: getRouteSellerPage(':sellerId'),
    element: <SellerPage />,
    nested: {
      [AppRoutes.SELLER_COMPANY_INFO]: {
        roles: acceptableRolesForApp,
        path: getRouteCompanySellerPage(':sellerId'),
        element: <CompanyInfoPage />,
      },
      [AppRoutes.SELLER_MARKETING_INFO]: {
        roles: acceptableRolesForApp,
        path: getRouteMarketingSellerPage(':sellerId'),
        element: <MarketingInfoPage />,
      },
      [AppRoutes.SELLER_POLICIES_INFO]: {
        roles: acceptableRolesForApp,
        path: getRoutePoliciesSellerPage(':sellerId'),
        element: <PoliciesInfoPage />,
      },
      [AppRoutes.SELLER_USERS_INFO]: {
        roles: acceptableRolesForApp,
        path: getRouteUsersSellerPage(':sellerId'),
        element: <UsersInfoPage />,
      },
      [AppRoutes.SELLER_ADMIN_INTEGRATION]: {
        roles: [UserRole.REOPS_ADMIN],
        path: getRouteAdminIntegrationSellerPage(':sellerId'),
        element: <AdminIntegrationPage />,
      },
    },
  },
  [AppRoutes.SELLER_INTEGRATIONS]: {
    roles: [UserRole.SELLER_ADMIN, UserRole.SELLER_DEV],
    authOnly: true,
    path: getRouteSellerIntegrationsPage(':sellerId'),
    element: <IntegrationPage />,
    nested: {
      [AppRoutes.SELLER_INTEGRATIONS_OVERVIEW]: {
        roles: [UserRole.SELLER_ADMIN, UserRole.SELLER_DEV],
        path: getRouteSellerIntegrationsOverviewPage(':sellerId'),
        element: <IntegrationOverviewPage />,
      },
      [AppRoutes.SELLER_INTEGRATIONS_INBOUND_DOCS]: {
        roles: [UserRole.SELLER_ADMIN, UserRole.SELLER_DEV],
        path: getRouteSellerIntegrationsInboundDocsPage(':sellerId'),
        element: <IntegrationInboundDocsPage />,
      },
      [AppRoutes.SELLER_INTEGRATIONS_SELLER_REQS]: {
        roles: [UserRole.SELLER_ADMIN, UserRole.SELLER_DEV],
        path: getRouteSellerIntegrationsSellerReqsPage(':sellerId'),
        element: <IntegrationSellerReqsPage />,
      },
      [AppRoutes.SELLER_INTEGRATIONS_SELLER_DOCS]: {
        roles: [UserRole.SELLER_ADMIN, UserRole.SELLER_DEV],
        path: getRouteSellerIntegrationsSellerDocsPage(':sellerId'),
        element: <IntegrationSellerDocsPage />,
      },
      [AppRoutes.SELLER_INTEGRATIONS_CONFIG]: {
        roles: [UserRole.SELLER_ADMIN, UserRole.SELLER_DEV],
        path: getRouteSellerIntegrationsSellerConfigPage(':sellerId'),
        element: <IntegrationConfigPage />,
      },
    },
  },
  // error pages
  [AppRoutes.FORBIDDEN]: {
    authOnly: true,
    path: getRouteForbidden(),
    element: <ForbiddenPage />,
  },
  [AppRoutes.NOT_FOUND_PAGE]: {
    path: getRouteNotFound(),
    element: <NotFoundPage />,
  },
  // last
  [AppRoutes.NOT_FOUND]: {
    path: '*',
    element: <NotFoundPage />,
  },
};
